import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1b0f6a45: FaireBrandEntity = {
  token: "b_1b0f6a45",
  type: "brand",
  name: "Sweet Water Decor",
  avatarUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c7a4f3f8a1a53a218e01bf15869391220d90fd27889382baa6ee6cca50768221.png",
  logoUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c7a4f3f8a1a53a218e01bf15869391220d90fd27889382baa6ee6cca50768221.png",
  location: "Pittsburgh, PA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 3215,
  isTopShop: true,
  isInsider: true,
  description:
    "At Sweet Water Decor, we create products that bring warmth, light, and inspiration into homes and everyday life. Our collection includes non-toxic candles, thoughtfully designed coffee mugs, motivational stationery, home accents, and curated gifts, all designed to delight and inspire.\n\nFrom our small beginnings to features on The Today Show, Good Morning America, Forbes, BuzzFeed, and Country Living, our mission has remained the same. We offer timeless, neutral home decor and meaningful gifts that motivate and uplift.\n\nEvery Sweet Water Decor product is thoughtfully designed under the direction of our founder, Melissa, who ensures each piece embodies our signature SWD aesthetic. At our Pittsburgh, PA headquarters, we craft non-toxic, clean-burning candles and premium reed diffusers using high-quality fragrance oils and our proprietary soy-based kosher wax. All of our candles and diffusers are gluten, lead, and phthalate-free, with many infused with essential oils for a beautifully balanced, elevated fragrance experience.\n\nJoin our Wholesale VIP Texts to be the first to know about new products, deals & restocks: https://sweetwaterdecor.attn.tv/p/Pyb/landing-page\n\nWe’re so excited to be part of your story and to have Sweet Water Decor in your shop.\n\nWarmly,\nThe Sweet Water Decor Team",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:55.974Z",
    importedBy: "entity-db-cli",
  },
};
